/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from 'antd/lib/antd/collapse/Collapse.tsx'
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import RcCollapse from 'rc-collapse';
import classNames from 'classnames';
import toArray from 'rc-util/lib/Children/toArray';
import omit from 'rc-util/lib/omit';
import { ExpandIconPosition } from 'antd/lib/collapse/Collapse';
import CollapsePanel from './CollapsePanel';
import { ConfigContext } from '../config-provider';
import collapseMotion from 'antd/lib/_util/motion';
import { cloneElement } from 'antd/lib/_util/reactNode';
import { Icon } from '../icon';
import warning from 'antd/es/_util/warning';
const Collapse = (props) => {
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const { prefixCls: customizePrefixCls, className = '', bordered = true, ghost } = props;
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    if (process.env.NODE_ENV !== 'production')
        warning(props.theme !== 'gray', 'collapse', `'themes = gray' is deprecated now`);
    warning(bordered !== false, 'collapse', `'bordered = false' is deprecated now`);
    const getIconPosition = () => {
        const { expandIconPosition } = props;
        if (expandIconPosition !== undefined) {
            return expandIconPosition;
        }
        return direction === 'rtl' ? 'right' : 'left';
    };
    const renderExpandIcon = (panelProps = {}) => {
        const { expandIcon, expandIconPosition } = props;
        // If the icon is on the left, turn it toward right when the panel is active.
        // If the icon is on the right, turn it toward down when the panel is active.
        const rotation = expandIconPosition === 'right' ? -90 : 90;
        console.log(expandIconPosition, 'expandIconPosition');
        const icon = (expandIcon ? (expandIcon(panelProps)) : expandIconPosition === 'right' ? (React.createElement(Icon, { type: 'chevron--left', size: 'small', rotate: panelProps.isActive ? rotation : undefined })) : (React.createElement(Icon, { type: 'chevron--right', size: 'small', rotate: panelProps.isActive ? rotation : undefined })));
        return cloneElement(icon, () => ({
            className: classNames(icon.props.className, `${prefixCls}-arrow`)
        }));
    };
    const iconPosition = getIconPosition();
    const collapseClassName = classNames({
        [`${prefixCls}-icon-position-${iconPosition}`]: true,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-ghost`]: !!ghost
    }, className);
    const openMotion = {
        ...collapseMotion,
        motionAppear: false,
        leavedClassName: `${prefixCls}-content-hidden`
    };
    const getItems = () => {
        const { children } = props;
        return toArray(children).map((child, index) => {
            if (child.props?.disabled) {
                const key = child.key || String(index);
                const { disabled, collapsible } = child.props;
                const childProps = {
                    ...omit(child.props, ['disabled']),
                    key,
                    collapsible: collapsible ?? (disabled ? 'disabled' : undefined)
                };
                return cloneElement(child, childProps);
            }
            return child;
        });
    };
    return (
    // @ts-ignore
    React.createElement(RcCollapse, { openMotion: openMotion, ...props, expandIcon: renderExpandIcon, prefixCls: prefixCls, className: collapseClassName }, getItems()));
};
Collapse.Panel = CollapsePanel;
Collapse.displayName = 'Collapse';
// export default withConfigProvider(Collapse);
export default Collapse;
